import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#0F1A32] text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src="/cybertek-logo.png" 
              alt="CyberTek Technology" 
              className="h-16 w-auto"
            />
            <p className="text-sm text-gray-400">
              Professional IT services and network architecture solutions for growing businesses.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-[#2995FF] transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#2995FF] transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#2995FF] transition-colors">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-[#2995FF] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-[#2995FF] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-[#2995FF] transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/careers" className="hover:text-[#2995FF] transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/news" className="hover:text-[#2995FF] transition-colors">
                  News & Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#2995FF] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-[#2995FF] transition-colors cursor-pointer">Network Architecture</li>
              <li className="hover:text-[#2995FF] transition-colors cursor-pointer">IT Infrastructure</li>
              <li className="hover:text-[#2995FF] transition-colors cursor-pointer">Cloud Solutions</li>
              <li className="hover:text-[#2995FF] transition-colors cursor-pointer">Cybersecurity</li>
              <li className="hover:text-[#2995FF] transition-colors cursor-pointer">Microsoft 365</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <Mail size={16} className="mt-1 text-[#2995FF]" />
                <div>
                  <a href="mailto:info@cybertektechnology.com" className="hover:text-[#2995FF] transition-colors">
                    info@cybertektechnology.com
                  </a>
                </div>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={16} className="text-[#2995FF]" />
                <a href="tel:+13109011799" className="hover:text-[#2995FF] transition-colors">
                  (310) 901-1799
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin size={16} className="mt-1 text-[#2995FF]" />
                <span>United States</span>
              </li>
              <li className="mt-4 pt-4 border-t border-gray-700">
                <div className="font-semibold text-white mb-2">Business Hours</div>
                <div className="text-xs space-y-1">
                  <p>Mon - Sat: 8:00 AM - 8:00 PM</p>
                  <p>EST / CST / PST</p>
                  <p className="text-gray-400">Closed Sundays</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} CyberTek Technology. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
